import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import React, { useState, useCallback, useEffect } from 'react';

import CurrentStockChart from './Charts/CurrentStockChart';
import TimeLineChart from './Charts/TimeLineChart';
import ProjectList from './ProjectList';
import exportToExcel from './ExportToExcel';

import ModalBox from './ModalBox';
import SideBar from './SideBar';


import Paper from '@mui/material/Paper';

import LoadData from '../utils/LoadData';
import ExportToExcel from './ExportToExcel';



const DashboardLayout = () => {


    const [modalField, setModalField] = useState("");
    const [open, setOpen] = useState(false);
    const handleOpen = (modal) => {
        setModalField(modal)
        setOpen(true)
    };
    const handleClose = () => {setOpen(false)};

    const [dataLoaded, setDataLoaded] = useState(false)


    const [chartPage, setChartPage] = useState({
        "timeLine": true,
        "currentStock": false,
    })

    // Control F to open the searchfield
    const handleKeyPress = useCallback((event) => {
        if (event.key === 'p') {
            event.preventDefault();
            handleOpen("weeks");
        }
        if (event.key === 't') {
            event.preventDefault();
            handleOpen("items");
        }
    }, []);

    useEffect(() => {
        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    
        // remove the event listener
        return () => {
        document.removeEventListener('keydown', handleKeyPress);
        };
    }, [handleKeyPress]);

    

  return (
        <Box sx={{display: 'flex', flexDirection:"column"}}>
            <LoadData 
                dataLoaded = {dataLoaded}
                setDataLoaded = {setDataLoaded}
                />
            <SideBar onHover={false} setChartPage={setChartPage}/>
            <ModalBox  
                open={open}
                handleClose={handleClose}
                modalField={modalField}
            >
            </ModalBox>
            <div>
                
                <Button
                    sx={{margin: "10px"}}
                    variant="contained"
                    onClick={() => handleOpen("weeks")}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    disabled={!dataLoaded}
                >
                    Kies periode
                </Button>

                <Button
                    sx={{margin: "10px"}}
                    variant="contained"
                    onClick={() => handleOpen("items")}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    disabled={!dataLoaded}

                >
                    Kies tarieven
                </Button>

                <ExportToExcel />

                {/* <Button
                    sx={{margin: "10px"}}
                    variant="contained"
                    onClick={() => console.log("Exporteer naar Excel")}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    // disabled
                >
                    Exporteer naar Excel
                </Button> */}


            </div>

            <div style = {{display: 'flex', flexDirection:'row', width:"95vw", margin: 'auto'}}>
            <Paper 
                sx={{ flex: 5, overflow: 'hidden', marginRight: "20px", padding: "10px"}}
                elevation={3}
            >
                <Box sx={{ width: '100%', overflow: 'hidden' }}>
                    {chartPage.timeLine && <TimeLineChart />}
                    {chartPage.currentStock && <CurrentStockChart />}
                    {/* <Chart /> */}
                </Box>
            </Paper>

        {chartPage.timeLine &&
                    <Paper 
                        sx={{ 
                            flex:1, 
                            overflowX: 'hidden',
                            overflowY: 'scroll',
                            margin: "auto", 
                            padding: "10px",
                            maxHeight: "80vh",
                        }}
                        elevation={3}
                    >
                        <Box sx={{ width: '100%', overflow: 'hidden' }}>
                            <ProjectList />
                        </Box>
                    </Paper>
        }
            </div>



            {/* <Chart /> */}
        </Box>
  )
}

export default DashboardLayout